/* Who else is in this document right now - up to five chips, then +N.
   Shared by the Spec Studio (masters) and the Designer (project specs).
   Styles: `.sps-peers` / `.sps-peer` in editor-chrome/editor.css. */

import { initialsOf, summarizePeers, type CollabPeer } from './collabState';

export function PeerChips({ peers }: { peers: CollabPeer[] }) {
  if (!peers.length) return null;
  const { shown, extra } = summarizePeers(peers);
  const everyone = peers.map((p) => p.name).join(', ');
  return (
    <span className="sps-peers" role="group" aria-label={`Also editing: ${everyone}`}>
      {shown.map((p) => (
        <span key={p.name} className={`sps-peer collab-c${p.slot}`} title={p.name}>
          {initialsOf(p.name)}
        </span>
      ))}
      {extra > 0 && (
        <span className="sps-peer sps-peer-more" title={everyone}>
          +{extra}
        </span>
      )}
    </span>
  );
}
